import { BaseFieldClass } from './baseField.class'

import { IFileListField, IImageValue } from '@/types/serverField.type'

export class FileListFieldClass extends BaseFieldClass {
  declare fieldValue: IImageValue[] | null
  declare initialValue: IImageValue[] | null

  constructor (field: IFileListField) {
    super(field)

    const value = field.Value ?? field.DefaultValue
    this.initialValue = this.prepareValue(value as IImageValue[] | null)
    this.fieldValue = this.prepareValue(value as IImageValue[] | null)
  }

  prepareValue (value: IImageValue[] | null): IImageValue[] | null {
    return value
  }

  getValue () {
    const result: Record<string, unknown> = {}
    const values = this.fieldValue || []
    if (Array.isArray(values) && values.length) {
      values.forEach((item, i) => {
        result[`${this.name}__${i}`] = item.Deleted === true
          ? JSON.stringify({ Uuid: item.Uuid, Delete: true })
          : item
      })
    } else {
      result[this.name] = null
    }
    return result
  }

  appendToFormData (formData: FormData): void {
    if (!this.value) return

    const values = this.fieldValue as any[]
    values?.forEach((item, i) => {
      const val = item.Deleted === true && !(item instanceof File)
        ? JSON.stringify({ Uuid: item.Uuid, Delete: true })
        : item
      formData.append(`${this.name}__${i}`, val)
    })
  }

  getFilterValue (): null {
    return null
  }
}
